module.exports = __webpack_public_path__ + "media/components/assets/img/bg/noise-contact-cc11ade131326167d84d64b6e0dc029b.svg";